module.exports = __webpack_public_path__ + "img/card.ef95b24a.svg";